import type {
  CreateImageBuildRequest,
  CreateImageBuildResponse,
  ImageBuild,
  ImageBuildDetailedResponse,
  ImageBuildSummaryResponse,
  UpdateImageBuildRequest,
  UpdateImageBuildResponse,
} from "./contracts";

import { axiosMediaBuilder as axiosFetch } from "./axiosMediaBuilder";

const endpoint = "/api/imageBuilds";

export async function getImageBuilds(
  includeUserBuilds?: boolean
): Promise<ImageBuildSummaryResponse[]> {
  let url = endpoint;
  if (includeUserBuilds !== undefined && includeUserBuilds !== null) {
    url += `?includeUserBuilds=${includeUserBuilds}`;
  }
  return axiosFetch.safeGet(url);
}

export async function getImageBuildById(
  id: string
): Promise<ImageBuildDetailedResponse> {
  return axiosFetch.safeGet(`${endpoint}/${id}`);
}

export async function createImageBuild(
  body: CreateImageBuildRequest
): Promise<CreateImageBuildResponse> {
  const response = await axiosFetch.safePost<
    CreateImageBuildRequest,
    any,
    any,
    CreateImageBuildResponse
  >(endpoint, body);
  return response.data;
}

export async function updateImageBuild(
  body: UpdateImageBuildRequest
): Promise<UpdateImageBuildResponse> {
  const response = await axiosFetch.safePut<
    UpdateImageBuildRequest,
    any,
    any,
    UpdateImageBuildResponse
  >(endpoint, body);
  return response.data;
}

export async function deleteImageBuild(id: string) {
  return axiosFetch.del(`${endpoint}/${id}`);
}

export async function previewImageBuild(build: ImageBuild): Promise<File> {
  const response = await axiosFetch.safePost<ImageBuild, any, any, File>(
    `${endpoint}/preview`,
    build,
    undefined,
    undefined,
    (config) => {
      config.responseType = "blob";
      return config;
    }
  );
  return response.data;
}